var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1833_4535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19513 11.7176L5.82285 14.0899C3.08088 16.6983 -0.729135 12.8986 1.88961 10.1464C2.68036 9.36587 4.64185 7.39411 5.39153 6.64443C7.30167 4.70348 10.6906 6.33635 10.1361 9.06805C10.1361 9.08859 11.1425 8.0719 11.1733 8.05137C10.8447 4.88834 6.819 3.72787 4.67266 5.92556L1.17074 9.42749C-0.349161 10.9474 -0.37997 13.3915 1.10912 14.8806C2.55713 16.38 5.11425 16.2876 6.56226 14.819L9.84853 11.5328C9.32478 11.6868 8.75995 11.7998 8.21567 11.7176H8.19513Z",
    fill: "#093549"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42748 1.18082L6.14121 4.46708C6.66496 4.31304 7.22979 4.20007 7.77407 4.28223L10.1463 1.90996C11.81 0.123052 15.0449 1.34513 14.9422 3.83037C14.9422 4.59032 14.6239 5.30919 14.0899 5.85348L10.5879 9.3554C8.68807 11.2861 5.28884 9.67376 5.85366 6.93178C5.83312 6.92151 4.85752 7.91766 4.81644 7.94847C5.05264 10.6596 8.36971 12.1179 10.5879 10.6391C11.2863 10.2694 14.1823 7.14744 14.819 6.57235C18.3517 2.8753 13.1759 -2.37246 9.42748 1.18082Z",
    fill: "#093549"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1833_4535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.9589,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.158745c166e4bbb3a0d5e6bccc2c2b99.svg";
export { ForwardRef as ReactComponent };